import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wrapper-news" }
const _hoisted_2 = { class: "above-info" }
const _hoisted_3 = { class: "wrapper-news" }
const _hoisted_4 = { class: "news-title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "wrapper-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCreateEditNews = _resolveComponent("ModalCreateEditNews")!
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_StandardButton = _resolveComponent("StandardButton")!
  const _component_EditButton = _resolveComponent("EditButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalCreateEditNews, {
      news: _ctx.selectedNews,
      onClose: _ctx.closeInformationNewsModal,
      onCreate: _ctx.createNewsTransaction,
      onEdit: _ctx.editNewsTransaction
    }, null, 8, ["news", "onClose", "onCreate", "onEdit"]), [
      [_vShow, _ctx.modalInfoNews]
    ]),
    _withDirectives(_createVNode(_component_ModalConfirmation, {
      message: _ctx.confirmMessage,
      onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeConfirmModalAsync(_ctx.deleteNewsTransaction))),
      onDeny: _ctx.closeConfirmModalAsync
    }, null, 8, ["message", "onDeny"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Noticias", -1)),
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Crear noticia',
          onClick: _ctx.createNewNews
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news, (news, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "news",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(news.title), 1)
            ]),
            _createVNode(_component_EditButton, {
              onClick: ($event: any) => (_ctx.editNewsSelected(news)),
              type: 'Edit'
            }, null, 8, ["onClick"]),
            _createVNode(_component_DeleteButton, {
              onClick: ($event: any) => (_ctx.selectDeletedNews(news)),
              type: 'Delete'
            }, null, 8, ["onClick"]),
            _createElementVNode("img", {
              src: news.slider,
              class: "news-image"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(news.body), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}